import script from "./ServiceCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCalendar.vue?vue&type=style&index=0&id=e976fefc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e976fefc"]])

export default __exports__